<template>
  <div class="profile-input-wrapper">
    <profile-form ref="form" endpoint="birthdate" @error="$emit('done', $event)">
      <form class="form">
        <fieldset>
          <legend class="sr-only">{{ inputTitle }}</legend>
          <div class="flex-grid-1-col gutter-lg">
            <div class="input">
              <input
                type="date"
                :class="[{ 'no-value': !formattedDate }, { valid: !!formattedDate }]"
                class="req"
                v-model="formattedDate"
                :max="maxDate"
                id="birthDate"
                name="birthDate"
                data-clear="true"
                data-val="true"
                :data-val-required="getValidationForField('required', 'birthDate')"
                data-field-type="SingleLineText"
              />
              <label for="birthDate" class="req floating">
                {{ tc('profile.formFields.birthDate') }}
              </label>

              <span
                data-valmsg-for="birthDate"
                data-valmsg-replace="true"
                class="field-validation-valid"
              ></span>
            </div>
          </div>
        </fieldset>
      </form>
    </profile-form>
    <div class="profile-info">
      <div class="profile-info-icon icon-info"></div>
      <div class="profile-info-section">
        <div class="profile-info-section-title">
          {{ tc('profile.dataUseInfo.title') }}
        </div>
        <div class="profile-info-section-description">
          {{ tc('profile.dataUseInfo.description.birthDate') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ProfileInputMixin from '@mixins/profile-input-mixin'
  import { formatDateZone } from '@utils/date-helpers'

  export default {
    name: 'profile-birthday-input',
    mixins: [ProfileInputMixin],
    data: () => ({
      localProfile: {
        birthDate: ''
      }
    }),
    computed: {
      formattedDate: {
        get() {
          return formatDateZone(this.localProfile.birthDate, null, 'YYYY-MM-DD')
        },
        set(newValue) {
          return newValue
        }
      },
      maxDate() {
        const now = new Date()
        return now.toISOString().substring(0, 10)
      }
    }
  }
</script>
